import { checkTriveltaProduct } from "../../hooks/useTriveltaProduct";
import { GAME_PASS_PAM_UNLOCKED_OPTION_IDS } from "../gamePassFeature";

export const normalizeAccessRoles = (accessRole) => {
  if (accessRole == null || accessRole === "") return [];
  if (Array.isArray(accessRole)) {
    return accessRole.filter(
      (role) => typeof role === "string" && role.length > 0,
    );
  }
  return typeof accessRole === "string" ? [accessRole] : [];
};

export const hasPermission = (adminPermissions, permission) =>
  adminPermissions?.includes(permission) === true;

export const hasAnyPermission = (
  adminPermissions,
  permissions,
  { developmentMode = false, isDevEnv = false } = {},
) =>
  (developmentMode && isDevEnv) ||
  (Array.isArray(permissions) &&
    permissions.some((permission) =>
      hasPermission(adminPermissions, permission),
    ));

export const isDevOptionUnlocked = (option, isDevEnv) =>
  Boolean(option.development_mode && isDevEnv);

export const filterSidebarOptions = (
  options,
  {
    adminPermissions,
    isWhitelisted,
    isDevEnv,
    gamePassPamBypass = false,
    checkProduct = checkTriveltaProduct,
  },
) =>
  (Array.isArray(options) ? options : []).reduce(
    (filteredOptions, option) => {
      if (!isWhitelisted(option.user_whitelist)) {
        return filteredOptions;
      }

      if (
        option.required_product &&
        !checkProduct(option.required_product, undefined, {
          catalogOnly: option.required_product_catalog_only,
        })
      ) {
        return filteredOptions;
      }

      if (option.development_mode && !isDevEnv) {
        return filteredOptions;
      }

      const filteredChildren = Array.isArray(option.children)
        ? filterSidebarOptions(option.children, {
            adminPermissions,
            isWhitelisted,
            isDevEnv,
            gamePassPamBypass,
            checkProduct,
          })
        : undefined;
      const hasVisibleChildren =
        Array.isArray(filteredChildren) && filteredChildren.length > 0;
      const accessRoles = normalizeAccessRoles(option.access_role);
      const hasPamBypass =
        gamePassPamBypass &&
        GAME_PASS_PAM_UNLOCKED_OPTION_IDS.has(option.id);
      const hasPermissionForOption =
        accessRoles.length === 0 ||
        accessRoles.some((role) => hasPermission(adminPermissions, role)) ||
        hasPamBypass;
      const canAccessOption = option.development_mode
        ? isDevOptionUnlocked(option, isDevEnv) ||
          (accessRoles.length > 0 && hasPermissionForOption) ||
          hasPamBypass
        : hasPermissionForOption;

      if (Array.isArray(option.children)) {
        if (
          !hasVisibleChildren &&
          option.children.length > 0 &&
          (!canAccessOption || (!option.navigate && !option.allowEmptyMenu))
        ) {
          return filteredOptions;
        }

        filteredOptions.push({ ...option, children: filteredChildren });
      } else if (canAccessOption) {
        filteredOptions.push(option);
      }

      return filteredOptions;
    },
    [],
  );
